import {Injectable, signal} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {KtTripFilterForm, KtTripFilterModel} from '../models/kt-filter.model';

@Injectable({providedIn: 'root'})
export class KtTripsFilterService {
  public readonly filtersValue = signal<KtTripFilterModel>(this.buildDefaultFilters());
  public readonly toggleModal = signal<boolean>(false);

  private readonly filters$ = new BehaviorSubject<KtTripFilterModel>(this.filtersValue());

  public get form(): KtTripFilterForm {
    return new FormGroup({
      TripReference: new FormControl<string | null>(null),
      ClientName: new FormControl<string | null>(null),
      AgentName: new FormControl<string | null>(null),
      VendorName: new FormControl<string | null>(null),
      BookedDateFrom: new FormControl<Date | null>(null),
      BookedDateTo: new FormControl<Date | null>(null),
      TripStartDateFrom: new FormControl<Date | null>(null),
      TripStartDateTo: new FormControl<Date | null>(null),
      IsCancelled: new FormControl<boolean | null>(null),
    });
  }

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: KtTripFilterModel): void {
    this.filtersValue.set(value);
    this.filters$.next(value);
  }

  private buildDefaultFilters(): KtTripFilterModel {
    return {
      TripReference: null,
      ClientName: null,
      AgentName: null,
      VendorName: null,
      BookedDateFrom: null,
      BookedDateTo: null,
      TripStartDateFrom: null,
      TripStartDateTo: null,
      IsCancelled: null,
      ReloadGrid: false,
    };
  }
}
